import { render } from "./Blog4.vue?vue&type=template&id=490a01aa"
import script from "./Blog4.vue?vue&type=script&lang=js"
export * from "./Blog4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__